/* PRELUDIO v29 - taglie numeriche dei capi Kids (Bambina/Bambino, abbigliamento) mostrate come eta': "6" -> "6 anni", "1" -> "1 anno".
   Caricato solo sulle schede Kids di abbigliamento (condizione in sections/preludio-menu.liquid). Cambia solo il testo a schermo: valore della variante, carrello e ordine invariati. */
(function () {
  function anni() {
    var el = [];
    document.querySelectorAll('x-popover[id^="popover-variant-dropdown"] .popover__value-option').forEach(function (o) { var v = o.querySelector('span'); if (v) el.push(v); });
    document.querySelectorAll('main variant-picker button.select span[id$="-selected-value"]').forEach(function (v) { el.push(v); });
    el.forEach(function (v) { var t = v.textContent.trim(); if (/^\d{1,2}$/.test(t) && +t >= 1 && +t <= 16) v.textContent = t + (t === '1' ? ' anno' : ' anni'); });
  }
  function avvia() {
    anni();
    if (!window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(anni, 60); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
